export default __webpack_public_path__ + "static/media/SQS-ISO-45001.1a027bb4.jpg";